import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/navbar/Navbar';
import Card from '../components/layout/card';
import H4 from '../components/font/H4';
import ReactMarkdown from 'react-markdown';
import BlogPreview from '../components/blogPreview/BlogPreview';
import SEO from '../components/SEO';

const localBlogs = [
    {
      id: 'why-ai-is-better-scheduling-gutter-cleaning',
      title: "Why AI is better at scheduling your gutter cleaning than you are",
      image: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80&w=2070",
      content: "Gutters aren't glamorous, but letting them clog is a $15,000 mistake. Here is how our task triage engine monitors your roof history to schedule seasonal clear-outs flawlessly."
    },
    {
      id: 'what-is-a-digital-twin-residential',
      title: "What is a Digital Twin for a Residential Property?",
      image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&q=80&w=2070",
      content: "The concept of a Digital Twin has existed in enterprise architecture for decades. Now, HomeButler is bringing it to residential assets. Here is what it means for your property value."
    },
    {
      id: 'how-home-health-score-works',
      title: "How your Home Health Score works",
      image: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=2070",
      content: "Your home is your biggest investment, yet you likely rely on memory to maintain it. The Home Health Score aggregates manufacturer service intervals to evaluate risk proactively."
    },
    {
      id: 'best-home-management-apps-2026',
      title: "The 5 Best Home Management Apps for Millennial Homeowners in 2026",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80&w=2070",
      content: "If you're still using a messy folder of paper receipts or an outdated Excel spreadsheet to track your home's maintenance, you're losing money. The modern homeowner needs a system that does the thinking for them."
    },
    {
      id: 'average-cost-to-replace-hvac-atlanta',
      title: "Average Cost to Replace HVAC in Atlanta (2026 Data)",
      image: "https://images.unsplash.com/photo-1581094288338-2314dddb7ece?auto=format&fit=crop&q=80&w=2070",
      content: "Replacing an HVAC system is one of the most expensive and stressful projects for any homeowner. The biggest hurdle? Asymmetric information. Contractors know the prices; you don't."
    },
    {
      id: 'first-year-home-maintenance-checklist',
      title: "The Ultimate First-Year Home Maintenance Checklist",
      image: "https://images.unsplash.com/photo-1581141849291-1125c7b692b5?auto=format&fit=crop&q=80&w=2070",
      content: "Congratulations, you bought a house! Once the dust settles and the moving boxes are unpacked, reality sets in: you are now fully responsible for the upkeep of this massive asset."
    },
    {
      id: 'how-to-prepare-your-home-for-hurricane-season',
      title: "How to Prepare Your Home for Hurricane Season",
      image: "https://images.unsplash.com/photo-1508697014387-db70aad34f4d?auto=format&fit=crop&q=80&w=2070",
      content: "Hurricane season peaks in August. Here's the homeowner's checklist for protecting your property—and the digital paperwork you need before the storm hits, not after."
    },
    {
      id: 'average-cost-to-replace-water-heater-charlotte',
      title: "Average Cost to Replace a Water Heater in Charlotte (2026 Data)",
      image: "https://images.unsplash.com/photo-1623986854909-279d5d194123?auto=format&fit=crop&q=80&w=2070",
      content: "A failing water heater rarely waits for a convenient time. Here's what Charlotte homeowners actually pay for a replacement, and how to spot an inflated quote."
    },
    {
      id: 'signs-your-roof-needs-repair',
      title: "Signs Your Roof Needs Repair Before It's Too Late",
      image: "https://images.unsplash.com/photo-1546668586-fc282cc41974?auto=format&fit=crop&q=80&w=2070",
      content: "Your roof rarely fails all at once. Here are the five warning signs that show up months before a leak—and why catching them early saves thousands."
    },
    {
      id: 'how-to-find-home-warranty-insurance-documents',
      title: "How to Actually Find Your Home Warranty and Insurance Documents When You Need Them",
      image: "https://images.unsplash.com/photo-1750935578389-6e1445f5fd8d?auto=format&fit=crop&q=80&w=2070",
      content: "Your home warranty and insurance policy are useless if you can't find them when something breaks. Here's how to build a system that actually works."
    }
];

function BlogPosts() {
    return (
        <div>
            <SEO
                title="Home Intelligence Blog | HomeButler"
                description="Actionable insights on home maintenance, repair costs, and protecting your property value using AI and HomeButler's Home Operating System."
                path="/blog"
            />
            <Navbar links={true} />
            <h2 className='text-center m-8 lg:mx-20'>Blog Posts</h2>
            <div className="m-8 lg:mx-20 flex flex-wrap justify-center gap-6">
                {localBlogs.map((post) => (
                    <div key={post.id} className="w-full sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/4 flex justify-center">
                        <Link to={`/blog/${post.id}`}>
                            <BlogPreview post={post} />
                        </Link>
                    </div>
                ))}
            </div>
        </div>

    );
}

export default BlogPosts;
